import { useState } from 'react';
import { useTrackingDomains } from './useTrackingDomains';
import { useTrackingProfiles } from './useTrackingProfiles';
import { Permission } from '../../../../../entities';

export const useTrackingDetails = (permissionsCodeList: string[] = []) => {
  const [downloadButton, setDownloadButton] = useState(false);
  const trackingProfiles = useTrackingProfiles();
  const trackingDomains = useTrackingDomains();

  const setDownloadButtonHandler = (show: boolean) => {
    setDownloadButton(show);
  };

  return {
    hookTrackingProfile: trackingProfiles,
    hookTrackingDomains: trackingDomains,
    hookDownloadButton: downloadButton,
    hookSetDownloadButton: setDownloadButtonHandler,

    hookIsReadOnlyList: Permission.readOnlyPermissionsList(permissionsCodeList),
  };
};
